module.exports = __webpack_public_path__ + "img/组 1118@2x (1).bb7bdd92.png";